import React, { useMemo, useEffect, useState, forwardRef, useImperativeHandle } from 'react';

// BOOTSTRAP
import Row from '~/components/Bootstrap/Row';
import { ColSm12, ColSm2, ColSm3, ColSm4, ColSm6, ColSm8 } from '~/components/Bootstrap/Col';
import InputGroup from '~/components/Bootstrap/InputGroup';
import Label from '~/components/Bootstrap/Label';

// COMPONENTES GERAIS
import Modal, { ModalHeader } from "~/components/Modal";

// STYLED COMPONENTS
import { Main, Content, Footer } from "./styles";

// INPUTS
import InputNormal from '~/components/Inputs/Normal/Normal';
import SelectNormal from '~/components/Selects/Normal/Normal';

// BUTONS
import ButtonPrimary from '~/components/Buttons/Normal/Primary';
import ButtonSecondary from '~/components/Buttons/Normal/Secondary';

// UTILS
import numeral from '~/utils/numeral';
import Utils from '~/utils';
import NotificacaoUtil from '~/utils/notificacao';

// SERVICES
import APIRequests from "~/services/requests_api";

const ModalCadastroEdicao = forwardRef(
    ({
        onConfirmCadEdit = () => { }
    }, ref) => {

        const [isVisible, setVisible] = useState(false);

        const [UUID, setUUID] = useState('');
        const [Descricao, setDescricao] = useState('');
        const [Endpoint, setEndpoint] = useState('');
        const [PortaSerial, setPortaSerial] = useState('');
        const [ControladoraID, setControladoraID] = useState('');

        const onRequestConfirm = async () => {

            try {

                if (!Descricao) {
                    throw new Error('Informe o descricao');
                }

                if (!Endpoint) {
                    throw new Error('Informe o endpoint');
                }

                if (!PortaSerial) {
                    throw new Error('Informe a porta serial');
                }

                if (!ControladoraID) {
                    throw new Error('Informe a porta serial');
                }

                const objeto_enviar = {
                    descricao: Descricao,
                    endpoint: Endpoint,
                    porta_serial: PortaSerial,
                    controladora_id: ControladoraID,
                }

                let retorno_api = {};
                if (UUID) {
                    retorno_api = await APIRequests.bicas_dagua.atualizar(UUID, objeto_enviar);
                } else {
                    retorno_api = await APIRequests.bicas_dagua.adicionar(objeto_enviar);
                }

                if (retorno_api?.id) {

                    NotificacaoUtil.success({
                        msg: UUID ? `Bica D'Agua atualizada com sucesso` : `Bica D'Agua cadastrada com sucesso`,
                    });

                    // fecha o modal
                    onRequestClose();

                    // dispara a função externa
                    onConfirmCadEdit();

                } else {
                    NotificacaoUtil.error({
                        msg: UUID ? `Erro ao atualizar a bica d'agua` : `Erro ao cadastrar a bica d'agua`,
                        timeout: 3500,
                    });
                }

            } catch (error) {
                NotificacaoUtil.error({
                    msg: error.message,
                    timeout: 3500,
                });
            }

        }

        const onRequestOpen = async (uuid = false) => {

            let visible = true;

            if (uuid) {

                const dados_bica = await APIRequests.bicas_dagua.obter(uuid);

                if (dados_bica.uuid) {

                    setUUID(dados_bica.uuid);
                    setDescricao(dados_bica.descricao);
                    setEndpoint(dados_bica.endpoint ?? '');
                    setPortaSerial(dados_bica.porta_serial ?? '');
                    setControladoraID(dados_bica.controladora_id ?? '');

                } else {
                    visible = false;
                    NotificacaoUtil.error({
                        msg: `Falha ao carregar os dados da bica d'água`
                    });
                }

            }

            if (visible) {
                setVisible(visible);
            }

        }

        const onRequestClose = () => {
            setVisible(false);

            // reseta o estado
            setUUID('');
            setDescricao('');
            setEndpoint('');
            setPortaSerial('');
            setControladoraID('');
        }

        const onKeyDown = (e) => {

            // pega o código pressionado
            const code = e.which !== false ? e.which : e.keyCode;

            // stop events
            if (code == 13 || code == 27) {
                e.preventDefault();
            }

            if (code == 13) {
                onRequestConfirm();
            }

            if (code == 27) {
                onRequestClose();
            }

        }

        /**
         * Passa a função de buscar para fora do input via ref.
         */
        useImperativeHandle(ref, () => (
            {
                open: onRequestOpen,
                close: onRequestClose
            }
        ));

        return (
            <Modal
                isVisible={isVisible}
                setVisible={onRequestClose}
                closeButtonVisible={false}
                closeOnClickOutside={false}
                width={520}
                height={460}
            >
                <Main>
                    <ModalHeader>
                        {UUID ? 'Edição' : 'Cadastro'} de Bica D'Agua
                    </ModalHeader>

                    <Content>

                        <Row>
                            <ColSm12>
                                <Label>UUID</Label>
                                <InputNormal
                                    value={UUID}
                                    disabled
                                    style={{ textAlign: 'center' }}
                                />
                            </ColSm12>
                        </Row>

                        <Row>
                            <ColSm12>
                                <Label>Descricao</Label>
                                <InputNormal
                                    value={Descricao}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setDescricao(e.target.value)}
                                />
                            </ColSm12>
                        </Row>

                        <Row>
                            <ColSm12>
                                <Label>Endpoint (apenas url ou ip)</Label>
                                <InputNormal
                                    value={Endpoint}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setEndpoint(e.target.value)}
                                />
                            </ColSm12>
                        </Row>

                        <Row>
                            <ColSm6>
                                <Label>ID Controladora</Label>
                                <InputNormal
                                    value={ControladoraID}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setControladoraID(e.target.value)}
                                />
                            </ColSm6>
                            <ColSm6>
                                <Label>Porta Serial</Label>
                                <InputNormal
                                    value={PortaSerial}
                                    onKeyDown={onKeyDown}
                                    onChange={e => setPortaSerial(e.target.value)}
                                />
                            </ColSm6>
                        </Row>

                        <Footer>

                            <ButtonSecondary onClick={onRequestClose}>
                                Fechar
                            </ButtonSecondary>

                            <ButtonPrimary onClick={onRequestConfirm}>
                                OK
                            </ButtonPrimary>

                        </Footer>

                    </Content>
                </Main>
            </Modal>
        )

    }
);

export default ModalCadastroEdicao;